// @mui material components
import React, { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";

import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import IconButton from "@mui/material/IconButton";

import TimelineItem from "examples/Timeline/TimelineItem";
import toast from "react-hot-toast";
import { capitalCase } from "capital-case";
import { useForm, Controller } from "react-hook-form";

// Data
import { MANUFACTURER_SERVICES } from "utils/data";

const ServiceOffer = ({ store, updateStore, editable = true }) => {
  //Ideation, Sourcing, Technical Design, Sampling, Production
  const renderTimelineItems = MANUFACTURER_SERVICES.map((s, index) => {
    let services_offered = store?.metadata?.services_offered || {};

    let badges =
      services_offered[s.value] && services_offered[s.value]["tags"]
        ? services_offered[s.value]["tags"]
        : [];
    let description =
      services_offered[s.value] && services_offered[s.value]["descriptions"]
        ? services_offered[s.value]["descriptions"]
        : " ";

    return (
      <TimelineItem
        key={index}
        isEmpty={!services_offered.hasOwnProperty(s.value)}
        color={s.color}
        title={s.label}
        icon={s.icon}
        description={description}
        badges={badges}
        badgeTitle="Services"
        lastItem={index + 1 == MANUFACTURER_SERVICES.length}
      />
    );
  });

  return (
    <Card>
      <div className="m-4">
        <div className="my-2 flex justify-between">
          <SuiTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            Services We Offer
          </SuiTypography>
        </div>

        {renderTimelineItems}
      </div>
    </Card>
  );
};

export default ServiceOffer;
